import React from 'react';
import { Item, Button, Label } from 'semantic-ui-react';
import { ItemHeader, ItemDescription } from './collection-item.styles';

const FavItem = ({
  id,
  name,
  full_day_price,
  half_day_price,
  image,
  description,
  handleClearRental,
  handleAddRentalToCart,
  handleRidectToRental,
}) => {
  return (
    <Item>
      <Item.Image size='small' src={image || '/images/fallback.png'} />
      <Item.Content verticalAlign='middle'>
        <ItemHeader as='h3' onClick={() => handleRidectToRental(id)}>
          {name}
        </ItemHeader>
        <ItemDescription>{description}</ItemDescription>
        <Item.Meta style={{ marginTop: 40, marginBottom: 20}}>
          <Label basic color='teal'>
            Full day: $ {`${full_day_price}`}
          </Label>
          <Label basic color='teal'>Half day: $ {`${half_day_price}`}</Label>
        </Item.Meta>
        <Item.Extra>
          <Button
            positive
            floated='right'
            content='Rent'
            onClick={() =>
              handleAddRentalToCart({
                id,
                name,
                full_day_price,
                half_day_price,
                image,
              })
            }
          />
          <Button
            floated='right'
            onClick={() => handleClearRental(id)}
            content='Clear'
          />
        </Item.Extra>
      </Item.Content>
    </Item>
  );
};

export default FavItem;
